import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AccessUserInfo, UserLocationFacility } from 'src/app/models';
import { CreateLabRequestComponent } from '../../request/create-lab-request/create-lab-request.component';
import { DialogService } from 'primeng/dynamicdialog';
import { CustomDialogService, LabActionItemService, LabRequestService, UserService } from 'src/app/services';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { LoaderService } from 'src/app/services/loader.service';
import{LabActionItemTabDetail, noLabRequest} from 'src/app/models/water-lab/lab-action-item'
import { Table } from 'primeng';
import { CustomDatePipe } from 'src/app/pipes';


@Component({
  selector: 'bart-no-lab-request',
  templateUrl: './no-lab-request.component.html',
  styleUrls: ['./no-lab-request.component.scss'],
  providers: [DialogService, CustomDialogService,CustomDatePipe],
})
export class NoLabRequestComponent implements OnInit {
  @ViewChild('noLabRequestTable', { static: false }) noLabRequestTable: Table;
  @Input() selectedFacilityMasterId: number;
  @Input() userFacilities: UserLocationFacility[];
  @Output() refreshTabCount: EventEmitter<any> = new EventEmitter();
  @Input() tabDetails:LabActionItemTabDetail
  userDetail: any = null;
  noLabRequestActionItems: noLabRequest[]=[];
  cols: any[];
  constructor(public dialogService: CustomDialogService,private customDatePipe :CustomDatePipe, private _labActionItemService: LabActionItemService, private _loaderService: LoaderService,private _waterLabService: LabRequestService,private _userService: UserService) {
    this.userDetail = AccessUserInfo.getUserInfo();
  }
 
  ngOnInit() {
    this.cols = [
      
      { field: 'EquipmentDisplayName', header: 'Model # | Nickname | Serial # | Equipment ID', display: 'table-cell', width: "45%" },
      { field: 'DateOfOriginalInstall', header: 'Original Install Date', display: 'table-cell', width: "45%"}
    ];
   
    this.getNoLabRequestActionItems();
     //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userDetail.userName,
      userAction: UserAction.FILTER,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: "FacilityMasterID",
      value: this.selectedFacilityMasterId,
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_NO_LAB_REQUEST_GRID_LOADED
    });
    //#endregion
  }
  createRequest(equipmentID: any) {
    const ref = this.dialogService.open(CreateLabRequestComponent, {
      header: 'Create Lab Request',
      width: '70%',
      data: { labRequestId: null,selectedFacilityMasterId:this.selectedFacilityMasterId,equipMentID:equipmentID }
    })
    ref.onClose.subscribe(ref => {
        //this.getNoLabRequestActionItems();
        this.refreshTabCount.emit();     
    });
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userDetail.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: 'equipMentID',
      value: equipmentID,
      eventDescription: UserActionDescription.LABREQUEST_ACTION_ITEMS_CREATE_REQUEST_CLICKED
    });
    //#endregion
  }
  getNoLabRequestActionItems() {
    this._loaderService.show()
    let getNoLabRequestActionItemsParams = {
      "GETNOLABREQUESTACTIONITEMS": {
        facilitymasterid: this.selectedFacilityMasterId//this.facilityList.map(x => x.value).join(","),
      },
    }
    this.noLabRequestActionItems = [];
    this._labActionItemService.getNoLabRequestActionItems(JSON.stringify(getNoLabRequestActionItemsParams)).subscribe(data => {
      this.noLabRequestActionItems = data.GetNoLabRequestActionItems;
      this.noLabRequestActionItems.forEach(item =>
        {
          item.EquipmentDisplayName=item.EquipmentDisplayName
          item.DateOfOriginalInstall=this.customDatePipe.transform(item.DateOfOriginalInstall,"local","MM/dd/yyyy");
          item.DateOfOriginalInstallSort=new Date (this.customDatePipe.transform(item.DateOfOriginalInstall,"local","MM/dd/yyyy"));
        
        });
        if(this.noLabRequestActionItems && this.tabDetails.RecordCount!=this.noLabRequestActionItems.length)
        {
          this.tabDetails.RecordCount=this.noLabRequestActionItems.length
        }
      this._loaderService.hide();
      this.noLabRequestTable.reset();
    },
      err => {
        this._loaderService.hide()
      });

  }
  sortColumn(event) {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userDetail.userName,
      userAction: UserAction.SORT,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: event.field,
      value: event.order === 1 ? 'ASC' : 'DESC',
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_NO_LAB_REQUEST_COLUMN_SORT
    });
    //#endregion
  }
paginate(event) {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userDetail.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_NO_LAB_REQUEST_PAGE_NO_CLICKED
    });
    //#endregion
  }

}
